import React from 'react';
import { Link, withRouter } from "react-router-dom"
import {Input,Form,FormGroup,Label} from "reactstrap";
import { getStorageUser } from '../../helpers/api_helper';
const Columns = ( addUpd, destroy, active, setModalObserv) => {
	const authUser = getStorageUser();

	let columns = [
		{
			id: 'id',
			name: 'ID',
			selector: row => row.id,
			sortable: true,
			wrap: true,
			width:'5%',
		},
		{
			id: 'fecha',
			name: 'Fecha',
			selector: row => row.fecha,
			sortable: true,
			wrap: true,
			width:'15%'
		},
		{
			id: 'unit_id',
			name: 'Unidad',
			selector: row => `${row.unit.number}`,
			sortable: true,
			wrap: true,
			width:'15%'
		},
		{
			id: 'operator_id',
			name: 'Operador',
			selector: row => row.operator.name,
			sortable: true,
			width:'15%',
			wrap: true,

		},
		{
			id: 'tipo',
			name: 'Tipo',
			selector: row => row.tipo?.name,
			sortable: true,
			width:'25%',
			wrap: true,

		},
		{
			id: 'actions',
			name: 'Acciones',
			width:'15%',
			button: true,
			cell: row => (
				<div className="d-flex justify-content-between">
					<div className="p-2">
						<button onClick={() => setModalObserv({show:true,type:1,id:row.id})} className="btn btn-info btn-sm" title='Detalle de operador'>
							<i className="fa fa-eye"></i>
						</button>
					</div>
					<div className="p-2">
						<button className="btn btn-warning btn-sm" title='Editar operador' onClick={() => addUpd(row)}><i className="fas fa-edit"></i></button>
					</div>
					<div className="p-2">
						<button className="btn btn-danger btn-sm" title='Eliminar operador' onClick={() => destroy(row.id)}><i className="fas fa-trash"></i></button>
					</div>
				</div>
				),
		}
		];
	return columns;
}

export default Columns;